import { Pipe, PipeTransform } from '@angular/core';
import { CountryStateService } from '../services/country-state.service';

@Pipe({ name: 'country' })
export class CountryPipe implements PipeTransform {
  constructor(private countryStateService: CountryStateService) {}

  transform(value: string, returnType: 'name' | 'flag' | 'code' = 'name'): string {
    if (!value) return returnType === 'flag' ? '' : '-';

    const country = this.countryStateService.getCountryData(value);
    
    switch (returnType) {
      case 'flag': return country?.flag ?? '';
      case 'code': return country?.iso2?.toUpperCase() ?? '-';
      case 'name': 
      default: return country?.name ?? '-';
    }
  }
}